import React from 'react';
import logo from '../assets/logo.png';

const Footer = ({ scrollToHome, handleProdajaClick, handleIzdavanjeClick }) => {
  return (
    <footer className="bg-gray-900 text-white py-8 px-6 w-full">
      <div className="container mx-auto flex flex-col items-center md:flex-row justify-between space-y-4 md:space-y-0">
        {/* Logo i naziv kompanije */}
        <div className="flex flex-col items-center md:flex-row md:items-center space-y-2 md:space-y-0">
          <img src={logo} alt="Logo" className="h-10 md:h-12 mb-2 md:mb-0" />
          <span className="text-xs sm:text-sm text-gray-400">© {new Date().getFullYear()} Govedarica Milan. Sva prava zadržana.</span>
        </div>

        {/* Navigacija centrirana po x osi na velikim ekranima */}
        <nav className="flex gap-4 text-xs sm:text-sm md:order-2">
          <button
            onClick={scrollToHome}
            className="bg-transparent text-gray-400 hover:text-pink-500 transition duration-300 py-2 px-2 md:px-4 rounded"
            style={{ textShadow: '0 0 8px rgba(219, 39, 119, 1)' }}
          >
            Početna
          </button>
          <button
            onClick={handleProdajaClick}
            className="bg-transparent text-gray-400 hover:text-pink-500 transition duration-300 py-2 px-2 md:px-4 rounded"
            style={{ textShadow: '0 0 8px rgba(219, 39, 119, 1)' }}
          >
            Prodaja
          </button>
          <button
            onClick={handleIzdavanjeClick}
            className="bg-transparent text-gray-400 hover:text-pink-500 transition duration-300 py-2 px-2 md:px-4 rounded"
            style={{ textShadow: '0 0 8px rgba(219, 39, 119, 1)' }}
          >
            Izdavanje
          </button>
        </nav>

        {/* Socijalne mreže */}
        <div className="flex gap-4 mt-4 md:mt-0 md:order-3">
          <a
            href="https://facebook.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-400 hover:text-pink-500 transition duration-300 hover:shadow-[0_0_15px_rgba(219,39,119,0.8)]"
          >
            <svg
              className="w-5 h-5 md:w-6 md:h-6"
              fill="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M22.675 0H1.325C.594 0 0 .594 0 1.325v21.351C0 23.406.594 24 1.325 24H12.82v-9.294H9.692v-3.622h3.128V8.413c0-3.1 1.893-4.788 4.658-4.788 1.325 0 2.463.099 2.794.143v3.24h-1.917c-1.504 0-1.796.715-1.796 1.762v2.31h3.588l-.467 3.622h-3.12V24h6.116C23.406 24 24 23.406 24 22.676V1.325C24 .594 23.406 0 22.675 0z" />
            </svg>
          </a>
          <a
            href="https://twitter.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-400 hover:text-pink-500 transition duration-300 hover:shadow-[0_0_15px_rgba(219,39,119,0.8)]"
          >
            <svg
              className="w-5 h-5 md:w-6 md:h-6"
              fill="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M23.954 4.569c-.885.392-1.83.656-2.825.775 1.014-.608 1.794-1.574 2.163-2.723-.951.564-2.005.978-3.127 1.2-.897-.955-2.178-1.555-3.594-1.555-2.719 0-4.92 2.203-4.92 4.917 0 .386.044.763.128 1.124C7.691 8.094 4.067 6.13 1.64 3.161c-.423.722-.666 1.561-.666 2.475 0 1.71.87 3.216 2.188 4.099-.807-.026-1.566-.248-2.228-.616v.062c0 2.388 1.698 4.374 3.946 4.828-.413.111-.849.171-1.296.171-.316 0-.624-.031-.927-.088.631 1.953 2.445 3.377 4.6 3.417-1.68 1.319-3.809 2.105-6.102 2.105-.396 0-.786-.023-1.17-.067C2.914 21.29 6.355 22 10.061 22c12.073 0 18.675-10 18.675-18.675 0-.284-.006-.568-.019-.851A13.34 13.34 0 0024 4.59a13.157 13.157 0 01-3.761 1.03c1.355-.81 2.392-2.093 2.885-3.626z" />
            </svg>
          </a>
          <a
            href="https://instagram.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-400 hover:text-pink-500 transition duration-300 hover:shadow-[0_0_15px_rgba(219,39,119,0.8)]"
          >
            <svg
              className="w-5 h-5 md:w-6 md:h-6"
              fill="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M12 2.163c3.204 0 3.584.012 4.849.07 1.259.057 2.13.264 2.635.443.615.213 1.064.472 1.54.948.476.476.734.926.948 1.54.179.506.386 1.376.443 2.635.058 1.265.07 1.645.07 4.849s-.012 3.584-.07 4.849c-.057 1.259-.264 2.13-.443 2.635-.213.615-.472 1.064-.948 1.54-.476.476-.926.734-1.54.948-.506.179-1.376.386-2.635.443-1.265.058-1.645.07-4.849.07s-3.584-.012-4.849-.07c-1.259-.057-2.13-.264-2.635-.443-.615-.213-1.064-.472-1.54-.948-.476-.476-.734-.926-.948-1.54-.179-.506-.386-1.376-.443-2.635C2.175 15.583 2.163 15.204 2.163 12s.012-3.584.07-4.849c.057-1.259.264-2.13.443-2.635.213-.615.472-1.064.948-1.54.476-.476.926-.734 1.54-.948.506-.179 1.376-.386 2.635-.443C8.416 2.175 8.796 2.163 12 2.163zm0-2.163C8.741 0 8.332.013 7.052.073 5.775.134 4.731.365 3.843.734 2.963 1.098 2.264 1.697 1.697 2.264c-.567.567-1.166 1.266-1.53 2.146C0 5.27-.13 6.314-.073 7.591-.013 8.871 0 9.281 0 12s-.013 3.129-.073 4.409c-.057 1.277.139 2.321.267 2.741.364.88.963 1.579 1.53 2.146.567.567 1.266 1.166 2.146 1.53.42.128 1.464.324 2.741.267 1.28-.06 1.69-.073 4.409-.073s3.129.013 4.409.073c1.277.057 2.321-.139 2.741-.267.88-.364 1.579-.963 2.146-1.53.567-.567 1.166-1.266 1.53-2.146.128-.42.324-1.464.267-2.741-.06-1.28-.073-1.69-.073-4.409s.013-3.129.073-4.409c.057-1.277-.139-2.321-.267-2.741-.364-.88-.963-1.579-1.53-2.146-.567-.567-1.266-1.166-2.146-1.53-.42-.128-1.464-.324-2.741-.267C15.209 0 14.799 0 12 0z"/>
              <path d="M12 5.838c-3.406 0-6.162 2.756-6.162 6.162s2.756 6.162 6.162 6.162 6.162-2.756 6.162-6.162-2.756-6.162-6.162-6.162zm0 10.326c-2.295 0-4.162-1.866-4.162-4.162s1.866-4.162 4.162-4.162 4.162 1.866 4.162 4.162-1.866 4.162-4.162 4.162zm4.406-10.906c-.796 0-1.44.645-1.44 1.44s.645 1.44 1.44 1.44 1.44-.645 1.44-1.44-.645-1.44-1.44-1.44z"/>
            </svg>
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
